import { TransferTranslations } from "./transferTranslations.types";

const transferFrTranslations: TransferTranslations = {
    "transferPage": {
        "title": "Transfer",
    },
    transferFilters: {
        title: 'Préférences de transfert',
        options: {
            shortWaitingTime: 'Temps d\'attente court',
            doorToDoor: 'Porte à porte',
            privateGroup: 'Privé - uniquement pour votre groupe',
            carRental: 'Location de voiture',
        },
    },
    "bus": {
        title: 'Bus',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Peut nécessiter des changements de bus en route ou une marche jusqu\'à votre hébergement.',
        description: 'Un shuttle partagé avec des horaires fixes et plusieurs escales. Des changements de bus ou des marches peuvent être nécessaires.'
    },
    "busLesArcs": {
        title: 'Bus',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Peut nécessiter des changements de bus en route ou une marche jusqu\'à votre hébergement.',
        description: 'Un shuttle partagé avec des horaires fixes et plusieurs escales. Des changements de bus ou des marches peuvent être nécessaires.'
    },
    "taxi": {
        title: 'Taxi',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Service porte à porte',
        description: 'Un taxi privé avec un chauffeur dédié pour votre usage exclusif.'
    },
    "funicular": {
        title: 'Funiculaire',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Service porte à porte',
        description: 'Un funiculaire privé avec un chauffeur dédié pour votre usage exclusif.'
    }

}

export default transferFrTranslations;